import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    Typography,
} from "@mui/material"
import { useTranslation } from "react-i18next"
import React from "react"
import { ReactComponent as CloseIcon } from "../../assets/images/plus-circle-fill.svg"
import { ReactComponent as CommentIcon } from "../../assets/icons/chat.svg"

const CommentDialog = (props) => {
    const { data } = { ...props }
    const { t } = useTranslation()
    const handleClose = () => {
        props.setValue(false)
    };
    return (
        <React.Fragment>
            <Dialog
                onBackdropClick={() => { return false }}
                open={props.open}
                onClose={() => handleClose()}
                maxWidth="md"
                fullWidth={true}
                aria-labelledby="comment-dialog-title"
                aria-describedby="comment-dialog-description"
                PaperProps={{ sx: { p: "20px" } }}
            >
                <DialogTitle component="div" sx={{ display: "flex", alignItems: "center", p: "0 0 10px 0" }}>
                    <Typography fontWeight={600} fontSize={24} color="#404349">
                        {t('360Evaluation.label.comment')}
                    </Typography>
                    <CloseIcon style={{ marginLeft: "auto", cursor: "pointer" }} onClick={() => handleClose()} />
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ p: "10px 0 10px 0" }}>
                    <DialogContentText id="comment-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }} pt={0} component="div">
                        {
                            data && data?.length > 0 ?
                                data?.map(comment => {
                                    return (
                                        <Grid container mt={2}>
                                            <Grid item xs={12}>
                                                <Grid container item display="flex" alignItems="center">
                                                    <Box sx={{ background: "#EFF6F4", borderRadius: "0px 20px 20px 20px", p: "10px" }}>
                                                        <Typography fontWeight={400} fontSize={16} color="#404349">
                                                            {comment}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                }) :
                                <Grid container mt={2}>
                                    <Grid item xs={12}>
                                        <Grid container item display="flex" alignItems="center" flexDirection="column">
                                            <CommentIcon />
                                            <Typography fontWeight={600} fontSize={20} color="#888F9D" sx={{ mt: 1 }}>
                                                {t("360Evaluation.label.noFeedbackFounded")}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                        }
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};
export default CommentDialog
